import { render, staticRenderFns } from "./Mymailscore.vue?vue&type=template&id=6186ceb7&scoped=true"
import script from "./Mymailscore.vue?vue&type=script&lang=js"
export * from "./Mymailscore.vue?vue&type=script&lang=js"
import style0 from "./Mymailscore.vue?vue&type=style&index=0&id=6186ceb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6186ceb7",
  null
  
)

export default component.exports